import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { HttpHelper } from '../../helpers';
import { Observable } from 'rxjs';
import { Watchdog, Watchlist } from '../models';
import { CrudBaseService } from '../crud.service';

@Injectable()

export class WatchdogService extends CrudBaseService<Watchlist> {

    constructor(protected httpClient: HttpClient) {
        super('/watchdog', httpClient);
    }

    deleteWatchlist(id: number): Observable<any> {
        return this.httpClient.delete('/watchdog/' + id);
    }

    getByFingerprint(fingerprint: string, filterParams: any): Observable<Watchdog> {
        return this.httpClient.get(`/watchdog/fingerprint/${fingerprint}`, {
            params: HttpHelper.objectToHttpParams({ ...filterParams })
        }).pipe(map((res: any) => res && res.data));
    }

    getByIPAddress(ipAddress: string, filterParams: any): Observable<Watchdog> {
        return this.httpClient.get(`/watchdog/ip_address/${ipAddress}`, {
            params: HttpHelper.objectToHttpParams({ ...filterParams })
        }).pipe(map((res: any) => res && res.data));
    }
}
